export default function Header() {
	return (
		<div
			className={'header h-64 sm:h-160 bg-cover sm:bg-auto 2xl:bg-contain bg-black bg-no-repeat -mt-8 sm:-mt-12'}>
			<div className={'w-full h-full bg-gradient-to-l from-black flex items-center flex-row-reverse'}>
				<div
					className={'flex-wrap w-full xl:w-1/2 text-2xl sm:text-5xl leading-relaxed text-secondary-content text-right px-8 sm:px-20'}>
					<p>Grande ou pequeno:</p>
					<p>o seu projeto executado</p>
					<p>com qualidade e agilidade</p>
				</div>
			</div>
		</div>
	);
}